/* tslint:disable */
/* eslint-disable */
/**
 * CipherMail back-end API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */



/**
 * 
 * @export
 * @enum {string}
 */

export const PGPKeyGenerationType = {
    Rsa1024: 'RSA_1024',
    Rsa2048: 'RSA_2048',
    Rsa3072: 'RSA_3072',
    Rsa4096: 'RSA_4096',
    EccNistP256: 'ECC_NIST_P_256',
    EccNistP384: 'ECC_NIST_P_384',
    EccNistP521: 'ECC_NIST_P_521',
    EccBrainpoolP256: 'ECC_BRAINPOOL_P_256',
    EccBrainpoolP384: 'ECC_BRAINPOOL_P_384',
    EccBrainpoolP512: 'ECC_BRAINPOOL_P_512'
} as const;

export type PGPKeyGenerationType = typeof PGPKeyGenerationType[keyof typeof PGPKeyGenerationType];



